import React, { useEffect } from "react";
import PaymentDashboardRoutes from "./PaymentDashboardRoutes";
import { isErrorPage } from "../../../Contracts/Routes";
import { useUserStore } from "../../../Store/User";
import { useSubscriptionStore } from "../../../Store/Subscription";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";
import { useAxiosInterceptor } from "../../../Utils/AxiosInterceptorUtils";
import { isSubscriptionEnabled } from "../../../Utils/FeatureFlags";

const PaymentAppDashboard: React.FC = () => {
  const getCurrentUser = useUserStore(s => s.getCurrentUser);
  const getSubscriptionStatus = useSubscriptionStore(s => s.getSubscriptionStatus);
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  useAxiosInterceptor();

  useEffect(() => {
    if (isAuthenticated && !isLoading && !isErrorPage(location.pathname)) {
      getCurrentUser(getAccessTokenSilently);
      if (isSubscriptionEnabled) {
        getSubscriptionStatus(getAccessTokenSilently);
      }
    }
  }, [isAuthenticated, isLoading, getCurrentUser, getSubscriptionStatus, getAccessTokenSilently, location.pathname]);
  return (
    <>
      <PaymentDashboardRoutes />
    </>
  );
};

export default PaymentAppDashboard;
